import { Controller } from "@hotwired/stimulus"

// Shows/hides telehealth vs in_person field groups based on the
// delivery_mode select value. Triggered by change events on the select.
export default class extends Controller {
  static targets = ["telehealthFields", "inPersonFields"]

  connect() {
    this.reveal({ target: this.element.querySelector("select[name*='delivery_mode']") })
  }

  reveal(event) {
    const value = event.target?.value
    if (this.hasTelehealthFieldsTarget) {
      this.telehealthFieldsTarget.classList.toggle("hidden", value !== "telehealth")
    }
    if (this.hasInPersonFieldsTarget) {
      this.inPersonFieldsTarget.classList.toggle("hidden", value !== "in_person")
    }
  }
}
